import type {ConnectElementConfig} from '../ConnectElementList';
import {ComponentOverrideFlag} from '../../../utils/flags/flags';

export const TerminalHardwareShopConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "terminalHardwareShop" */
      '../../../components/Terminal/HardwareOrders/HardwareShop/TerminalHardwareShop'
    ),
  teamOwner: 'terminal-logistics-eng',
  sentryTeam: 'terminal_hardware_orders',
  enabledKey: 'terminal_hardware_shop',
  enabledOverrideFlag: ComponentOverrideFlag.terminal_hardware_shop,
  htmlEvents: ['oncheckoutfinished'],
  customHtmlElementMethods: {
    setOnCheckoutFinished: {
      type: 'EventListenerMethod',
      event: 'oncheckoutfinished',
      isInternal: false,
      description:
        'Sets the event listener for when the user has finished checking out terminal hardware order from shop',
    },
  },
  releaseState: 'preview',
  description: 'Shows shop for terminal hardware',
  friendlyName: 'Terminal Hardware Shop',
  docSitePath: '/connect/supported-embedded-components/terminal-hardware-shop',
  syntheticTestInfo: {
    testUrl:
      'https://amp.corp.stripe.com/synthetics/us-west-2/terminal-hardware-shop',
  },
};
